import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "./AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { IsTrueExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IsTrue";

export class IsTrueExpressionEditor extends ExpressionRuleEditor<IsTrueExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece>is true</ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
